import { useIntl } from "react-intl";

export const useCurrencySide = currency => {
	const { formatNumberToParts } = useIntl();

	const parts = formatNumberToParts(1, {
		style: "currency",
		currency,
		currencyDisplay: "symbol",
	});

	const currencySide = parts[0].type === "currency" ? "left" : "right";

	return currencySide;
};
